// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"7cce0902","203":"7cce0902","404":"33c9f899","557":"70a5367b","617":"5590e249","667":"7cce0902","753":"7cce0902","795":"5a1024bc","878":"696bd011","977":"53394b22"}[chunkId] + ".chunk.css";
};